import { apiFetch } from "./client";

export interface AiCredential {
  id: string;
  tenant_id: string;
  provider_kind: "openai_compatible" | "voyage_embedding";
  base_url: string;
  model: string;
  api_key_hint: string | null;
  is_active: boolean;
  is_default: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface AiCredentialUpsertBody {
  base_url: string;
  model: string;
  api_key: string;
}

export interface AiCredentialTestResult {
  status: "connected";
  message: string;
  provider_kind: "openai_compatible" | "voyage_embedding";
  base_url: string;
  model: string;
}

export const aiCredentialApi = {
  get: () => apiFetch<AiCredential>("/ai/credential"),

  upsert: (body: AiCredentialUpsertBody) =>
    apiFetch<AiCredential>("/ai/credential", {
      method: "POST",
      body: JSON.stringify(body),
    }),

  delete: () =>
    apiFetch<{ status: "deleted" }>("/ai/credential", {
      method: "DELETE",
    }),

  test: (body: AiCredentialUpsertBody) =>
    apiFetch<AiCredentialTestResult>("/ai/credential/test", {
      method: "POST",
      body: JSON.stringify(body),
    }),

  embedding: {
    get: () => apiFetch<AiCredential>("/ai/credential/embedding"),
    upsert: (body: AiCredentialUpsertBody) =>
      apiFetch<AiCredential>("/ai/credential/embedding", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    delete: () =>
      apiFetch<{ status: "deleted" }>("/ai/credential/embedding", {
        method: "DELETE",
      }),
    test: (body: AiCredentialUpsertBody) =>
      apiFetch<AiCredentialTestResult>("/ai/credential/embedding/test", {
        method: "POST",
        body: JSON.stringify(body),
      }),
  },
};
